<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide draggable :mask="false" draggable class="call_detail_pop" width="1200" >
    <div  style="height:530px;margin:0 auto;overflow-y:auto;overflow-x:hidden;color:red;">
        {{tipserror}}
    </div>
  </Modal>
</template>

<script>
    export default {
        name: "RecodePop",
        props: {
          showRecode:Boolean,
          tipserror:String
        },
        data(){
          return {
            title:'日志',
            model:false,
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeRecode",false);
          },
        },
        watch:{
          showRecode:function () {
            this.model=this.showRecode;
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/RecodePop.vue